import React, { useState, useEffect } from 'react';
import '../components/swatch.css';

import { DefaultColors } from '../components/jptr-default.js';


function SwatchList({ colors, onSwatchChange }) {

    const [swatchColors, setSwatchColors] = useState([]);
    const [currentSwatch, setCurrentSwatch] = useState(0);

    useEffect(() => {
        setSwatchColors(colors);
    }, [colors]);

    const handleSwatchClick = (id) => {
        const swatchId = Number(id);
        setCurrentSwatch(swatchId);

        if (onSwatchChange) {
            onSwatchChange(swatchId);
        }
    }

    return (
        <div className="flx-Hc-05">
            {swatchColors.map((swatchColor, index) => (
                <Swatch
                    key={index}
                    color={swatchColor}
                    id={index}
                    onSwatchClick={handleSwatchClick}
                    active={currentSwatch === index} />
            ))}
        </div>
    );
}

function Swatch({ color, id, active, onSwatchClick }) {

    const preStyle = {
        backgroundColor: color,
        borderRadius: active ? '50%' : '5px'
    };

    const handleSwatchClick = (e) => {
        if (onSwatchClick) {
            onSwatchClick(e.target.id);
        }
    };

    return <div className='swatch' id={id} style={preStyle} onClick={handleSwatchClick} />;
}

function SwatchRandom({ color = 'grey', id, active, onSwatchClick }) {

    const [swatchColor, setSwatchColor] = useState(color);

    const preStyle = {
        backgroundColor: swatchColor,
        borderRadius: active ? '50%' : '5px'
    };

    const handleSwatchClick = (e) => {

        const newColor = DefaultColors.randomRGB();

        setSwatchColor(newColor);

        if (onSwatchClick) {
            onSwatchClick(newColor);
        }
    };

    return <div className='swatchRandom' id={id} style={preStyle} onClick={handleSwatchClick} />;
}


const CardSep = (props) => {

    const [channelColor, setChannelColor] = useState('grey');

    useEffect(() => {
        setChannelColor(props.color);
    }, [props.color]);

    const handleClick = () => {
        console.log('Click:', props.title);
    }

    return (
        <div className='prvCard' onClick={handleClick}>
            <div className='prvCardTitle'>
                <h4>{props.title}</h4>
                <Swatch color={channelColor} />
            </div>
            <div class="image-container">
                <img src={props.src} className='prvSep' alt="Separation Preview" />
                <div class="color-overlay" style={{ backgroundColor: channelColor }}></div>
            </div>
        </div>
    );
}

const CardWhite = (props) => {

    const [channelColor, setChannelColor] = useState('blue');

    const handleBgColorId = (id) => {
        setChannelColor(DefaultColors.getRGB([id]));
    }

    const handleBgRandom = (color) => {
        setChannelColor(color);
    }

    return (
        <div className='prvCard'>
            <div className='prvCardTitle'>
                <SwatchRandom color={channelColor} onSwatchClick={handleBgRandom} />
                <h4>{props.title}</h4>
                <SwatchList colors={DefaultColors.getRGB([0, 1, 2, 3])} onSwatchChange={handleBgColorId} />
            </div>

            <div class="image-container" style={{ backgroundColor: channelColor, padding: '25px' }}>
                <img src={props.src} className='prvSep' alt="Preview" style={{ border: '1px dashed yellow' }}/>
            </div>
        </div>
    );
}

export {
    SwatchList,
    Swatch,
    CardSep,
    CardWhite
};